import { cn } from "@/utils/cn"
import type { ModalContentProps } from "./Modal.types"

type ModalStyleProps = Pick<ModalContentProps, "size" | "isVisible">

export const getModalStyles = ({ size = "md", isVisible }: ModalStyleProps) => {
  return {
    overlay: cn(
      "fixed inset-0 z-50 bg-dark-500/50 backdrop-blur-sm",
      "transition-opacity duration-200 ease-out",
      isVisible ? "opacity-100" : "opacity-0"
    ),

    wrapper: "fixed inset-0 z-50 flex items-center justify-center p-4",

    dialog: cn(
      "relative w-full overflow-y-auto rounded-[8px] bg-dark shadow-lg",
      "transition-all duration-200 ease-out",
      isVisible ? "scale-100 opacity-100" : "scale-95 opacity-0",
      {
        "w-fit max-w-sm": size === "sm",
        "w-fit max-w-md": size === "md",
        "w-fit max-w-lg": size === "lg",
        "w-fit max-w-[80vw]": size === "xl",
      }
    ),

    header: "flex items-center justify-between p-4 border-b border-dark-500",
    title: "text-lg font-bold text-dark-100",
    closeButton:
      "rounded-full p-1 text-dark-100 hover:bg-dark-100/50 hover:text-dark transition-colors",
    content: "p-4 text-dark-100",
  }
}
